module.exports = __webpack_public_path__ + "bz.09219a89104599121888.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/bz.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/bz.svg
// module chunks = styles